import { TariffWithVerificationValues } from '@src/stores/product';

/**
 * Checks if a specific field has an error (is empty when it should be filled)
 */
export const getFieldError = (
  tariffWithVerificationValues: TariffWithVerificationValues[],
  verificationId: string,
  tariffUnitIndex: number,
  verificationPosition: number,
): boolean => {
  const fieldValue = tariffWithVerificationValues.find((tariff) => {
    const verification = tariff.verificationValues?.find(
      (v) =>
        v.tariffVerificationId === verificationId &&
        v.tariffUnitIndex === tariffUnitIndex &&
        v.verificationPosition === verificationPosition,
    );

    return verification?.value === '';
  });
  return !!fieldValue;
};
